import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { apiFetch } from '../utils/api';
import { JOB_STATUS_LABELS } from '../utils/statusConstants';

const Jobs = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiFetch('/jobs')
      .then((r) => setJobs(r.data || []))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <h1 className="text-2xl font-semibold text-teal-800">My jobs</h1>
      <p className="text-slate-600 mt-1 mb-6">Assigned cleaning jobs</p>

      <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
        {loading ? (
          <p className="p-8 text-center text-slate-500">Loading…</p>
        ) : jobs.length === 0 ? (
          <p className="p-8 text-center text-slate-500">No assigned jobs yet.</p>
        ) : (
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-slate-600 text-left">
              <tr>
                <th className="px-5 py-3">Job #</th>
                <th className="px-5 py-3">Location</th>
                <th className="px-5 py-3">Scheduled</th>
                <th className="px-5 py-3">Status</th>
                <th className="px-5 py-3" />
              </tr>
            </thead>
            <tbody>
              {jobs.map((j) => (
                <tr key={j.id} className="border-t border-slate-100">
                  <td className="px-5 py-3 font-medium">{j.job_number}</td>
                  <td className="px-5 py-3">
                    {j.location_label || j.address_line1}
                    <span className="text-slate-500">
                      {j.city ? `, ${j.city}` : ''}
                    </span>
                  </td>
                  <td className="px-5 py-3">
                    {j.scheduled_start
                      ? new Date(j.scheduled_start).toLocaleString()
                      : '—'}
                  </td>
                  <td className="px-5 py-3">{JOB_STATUS_LABELS[j.status] || j.status}</td>
                  <td className="px-5 py-3 text-right">
                    <Link to={`/jobs/${j.id}`} className="text-teal-700 hover:underline">
                      Open
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default Jobs;
